import { createSelector } from 'reselect';

import getCartItems from './getCartItems';

const getCartItemInEdition = createSelector(
  getCartItems,
  (s, params) => params?.lineId,
  (items, lineId) =>
    lineId && items ? items.find(x => x.guid === lineId) : null,
);

export default getCartItemInEdition;
